vat breakdown

<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Sites">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'" @change="onChangeSites">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
 
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputTerminal: [],
                vatBreakdownReport: [],
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                JsonData: [],
                inputTransType: 0,
                filterStatus: 0,
                transactionTypes: []
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.inputTransType = 0

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToUpperCase(data){
                let uppercasedData = data.toUpperCase();
                return uppercasedData
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'vat_breakdown?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'letter' });
                    // let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    doc.addImage(reportLogo, "PNG", 10, 5, 15, 15);
                    let headers = [
                        {content: 'Site', styles: {halign: 'center'}},
                        {content: 'Date', styles: {halign: 'center'}},
                        {content: 'Amount', styles: {halign: 'center'}},
                    ]
                    let detailColStyles = {
                        0: {cellWidth: 60},
                        1: {cellWidth: 55},
                        2: {cellWidth: 50},
                    }

                    for(var x=0; x < siteSpecific.length; x++){
                        let grand_total = 0
                        this.vatBreakdownReport = siteSpecific[x].report_details

                        if(x > 0 && this.vatBreakdownReport.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        // report headers
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        let design_y = 20
                        design_y = design_y + 5;
                        doc.text(15,design_y,`Vat Breakdown Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
                        design_y = design_y + 10;
                        doc.text(15,design_y,"Site: " + siteSpecific[x].report_details[0].site)


                        this.vatBreakdownReport = siteSpecific[x].report_details
                        // report data
                        if(this.vatBreakdownReport.length > 0){
                            for(let i=0; i < this.vatBreakdownReport.length; i++){
                                let reportLine = this.vatBreakdownReport[i]
                                let detail = [
                                    {content: reportLine.site, styles: {halign: 'left'}},
                                    {content: moment(reportLine.business_date).format("YYYY-MM-DD"), styles: {halign: 'center'}},
                                    {content: this.convertToCurrency(Number(reportLine.amount_tax)), styles: {halign: 'right'}},
                                ]
                
                                grand_total += Number(reportLine.amount_tax)
                                reportData.push(detail)
                                
                                // let subtotal_detail = []
                                let grand_total_detail = []
                                if(i == this.vatBreakdownReport.length-1){
                                    grand_total_detail = ['',
                                        {content: 'Total: ', styles: {fontStyle: 'bold', halign: 'left'}},
                                        {content: this.convertToCurrency(grand_total), styles: {fontStyle: 'bold'}}
                                    ]

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(grand_total_detail)

                                    //create table
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [headers],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    // subtotal = 0
                                    // grand_total = 0
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    let pageCount = doc.internal.getNumberOfPages();
                    let footer_x = 195
                    let footer_y = 267
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Vat Breakdown Report", footer_x, footer_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let from_header = this.inputDate[0].format('YYYY-MM-DD');
                let to_header= this.inputDate[1].format('YYYY-MM-DD');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'vat_breakdown?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let site_specific = [];
                    for(var x=0; x < siteSpecific.length; x++){
                        this.vatBreakdownReport = siteSpecific[x].report_details
                        let headers = ['Site', 'Date', 'Amount']
                        let reportData = []
                        if(this.vatBreakdownReport.length > 0){
                            let grand_total = 0
                            for(let i=0; i < this.vatBreakdownReport.length; i++){
                                let reportLine = this.vatBreakdownReport[i]
                                let detail = [
                                    reportLine.site,
                                    moment(reportLine.business_date).format("YYYY-MM-DD"),
                                    this.convertToCurrency(Number(reportLine.amount_tax))
                                ]

                                grand_total += Number(reportLine.amount_tax)
                                reportData.push(detail)
                                
                                let grand_total_detail = []
                                if(i == this.vatBreakdownReport.length-1){
                                    grand_total_detail = ['','Total: ', this.convertToCurrency(grand_total)]
                                    reportData.push(grand_total_detail)
                                } else {
                                    //     sub_qty = 0
                                    //     sub_gross = 0
                                    //     sub_net = 0
                                    // }   
                                }
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push([])
                        reportData.push(["Site: " + siteSpecific[x].report_details[0].site])
                        reportData.push(["Vat Breakdown Report", "", "", "Generated By: " + printed_by])
                        reportData.push(["For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                            })));
                            newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                    obj[i] = '';
                                }
                            }
                        });
                        site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data');
                }
                this.spinning= false;
            },
            clearJsonData(){
                this.JsonData = [];
            },
            async onChangeSites(value){
                let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + value, null);
                this.terminalOptions = terminals;
                this.sort(this.terminalOptions);
            }
        }
    };
</script>

<style></style>